import React from 'react';
import { Updater, fromJSX, Widget } from "widgets-for-react";
import { State } from '../../../cmsPage.widget';
import { setSearchValueToState } from '../../../searchBar/searchBar.state';
import { SearchForm } from '../../../searchBar/searchBar.widget';
import { overviewWidget } from '../widgets/overviewWidget';
import { SearchPageLayout } from './searchPage.layout';
import i18next from 'i18next';

export const searchPageWidget = (state: State): Widget<Updater<State>> => {
  return fromJSX(setState => {
    return <div>
      {overviewWidget(state.searchPageState.overviewState, state).run(u => setState(s => ({ ...s, searchPageState: { ...s.searchPageState, overviewState: u(s.searchPageState.overviewState) } })))}
    </div>
  })
}

export const searchPageHeader = (state: State): Widget<Updater<State>> => {
  return fromJSX(setState => {
    const { searchState } = state.CMSHeaderState
    return (
      <>
        <SearchPageLayout.PageHeader />

        <SearchPageLayout.SearchHeader>
          <SearchForm
            label={i18next.t('Search:LabelSRT')}
            show={true}
            searchValue={state.CMSHeaderState.searchState.searchValue}
            updateSearchValue={searchValue => setState(state => setSearchValueToState(searchValue)(state))}
            submitSearchValue={() => {
              const newroute = `/${window.location.href.includes("/wp/") ? "wp" : ""}/zoeken?searchQuery=${searchState.searchValue}`
                .replace(/\/\//g, "/")
                .replace(/\/\//g, "/")
      
              window.history.pushState("", "", newroute)
              setState(_ => _)
            }}
          />
        </SearchPageLayout.SearchHeader>
      </>
    )
  })
}
